var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureServiceBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_132)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 129.423C132.898 129.423 135.61 128.291 137.664 126.237L157.97 105.931V104.851H102.004V105.931L122.336 126.237C124.39 128.291 127.102 129.423 130 129.423ZM139.586 128.159C137.032 130.741 133.635 132.136 130 132.136C126.365 132.136 122.968 130.739 120.414 128.159L102.004 109.777V147.149H157.97V109.777L139.586 128.159ZM82.2506 76.6173C82.0327 76.6041 81.8145 76.6374 81.6103 76.7148C81.4062 76.7922 81.2209 76.9121 81.0665 77.0665C80.9121 77.2208 80.7922 77.4062 80.7148 77.6103C80.6374 77.8145 80.6041 78.0327 80.6173 78.2506V98.0037C80.6173 99.0049 81.2753 99.6629 82.2506 99.6629H92.1272C93.1284 99.6629 93.7864 99.0049 93.7864 98.0037V89.7864H166.215V98.0296C166.215 99.0049 166.873 99.6629 168.19 99.6629H177.725C178.726 99.6629 179.384 99.0049 179.384 98.0296V78.2765C179.383 77.2753 178.725 76.6173 177.749 76.6173H82.2506ZM177.751 175.383C177.968 175.396 178.187 175.362 178.39 175.285C178.594 175.207 178.78 175.087 178.934 174.933C179.088 174.779 179.208 174.593 179.285 174.389C179.363 174.185 179.396 173.967 179.383 173.749V154.312C179.396 154.094 179.363 153.876 179.285 153.672C179.208 153.468 179.088 153.283 178.934 153.128C178.779 152.974 178.594 152.854 178.39 152.777C178.186 152.699 177.967 152.666 177.749 152.679H168.189C167.971 152.666 167.753 152.699 167.549 152.777C167.344 152.854 167.159 152.974 167.005 153.128C166.85 153.283 166.731 153.468 166.653 153.672C166.576 153.876 166.542 154.094 166.556 154.312V162.214H93.7864V153.996C93.7864 152.995 93.1284 152.337 91.8111 152.337H82.2506C81.2765 152.337 80.6173 152.995 80.6173 154.312V173.749C80.6041 173.967 80.6374 174.186 80.7148 174.39C80.7922 174.594 80.9121 174.779 81.0665 174.934C81.2209 175.088 81.4062 175.208 81.6103 175.285C81.8145 175.363 82.0327 175.396 82.2506 175.383H177.751Z",
    fill: "#0072C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_132",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureServiceBus);
export default __webpack_public_path__ + "static/media/azure-service-bus.8c632add72f51be6ff3f60fb1370f1eb.svg";
export { ForwardRef as ReactComponent };